import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Spinner, Subheading } from '@treams/treams-ui';

import LearningItemCard from './LearningItemCard';

const LearningEventsSlider = ({ title }: { title: string }) => {
	const { data } = graphql.useAttendingLearningEventsQuery();

	const events = data?.viewer.attendingLearningEvents.edges.filter(({ node }) => !node.isArchived);

	return (
		<>
			{events ? (
				events.length > 0 ? (
					<>
						<Subheading>{title}</Subheading>

						<Flex ml={-3} flexWrap="wrap">
							{events.map(({ node }) => (
								<Box key={node.id} width={[1, 1 / 2, 1 / 4, 1 / 4]} mt={3} pl={3}>
									<LearningItemCard event={node as graphql.LearningEvent} />
								</Box>
							))}
						</Flex>
					</>
				) : null
			) : (
				<Spinner centered />
			)}
		</>
	);
};

export default LearningEventsSlider;
